// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D6wC","left":"styles_left__2-FFP","desktopActions":"styles_desktopActions__2Nk-z","title":"styles_title__3HpXM"};